/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_DescriptionInputs */

const en_admin_users_description = /** @type {(inputs: Admin_Users_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage all registered users`)
};

/**
* | output |
* | --- |
* | "Manage all registered users" |
*
* @param {Admin_Users_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_users_description = /** @type {((inputs?: Admin_Users_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_users_description(inputs)
});
export { admin_users_description as "admin.users.description" }